import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent implements OnInit {

  messages: string[];

  constructor() { }

  ngOnInit(): void {
  }

  loadMessages() {

  }

  deleteMessage(i: number) {

  }

}
